"use strict";

angular.module("customer")
.service("PunchOutService", function(
    $resource, $http, $rootScope, $compile
) {
    this.orderSubmitted = function(payload) {
        var template = payload.template;
        var element = $compile(template)({});
        var formElement = element[0];
        var body = angular.element('body');
        body.append(formElement);
        formElement.submit();
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/cart/punch-out.service.js
// module id = 938
// module chunks = 0